module.exports = __webpack_public_path__ + "media/Triangle.cbdb451c.mp4";